import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router/index'

// 1. 创建 axios 实例
const service = axios.create({
  baseURL: 'https://www.xianyut.com',
  timeout: 5000 // 请求超时时间
})

// 2. 请求拦截器（发送请求前执行）
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    // 如果 token 存在，添加到请求头
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 请求错误时的处理
    console.error('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 3. 响应拦截器（收到响应后执行）
service.interceptors.response.use(
  response => {
    const res = response.data

    // 处理非 200 状态码（根据后端实际状态码调整）
    if (res.code !== 200) {
      // 错误提示
      Message({
        message: res.message || '操作失败',
        type: 'error',
        duration: 3000
      })

      // 特殊错误码处理：如 token 失效（401）、无权限（403）
      if (res.code === 401) {
        // 清除无效 token
        localStorage.removeItem('token')
        // 跳转到登录页（并记录当前路径，登录后可返回）
        router.push({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        })
      }

      return Promise.reject(res.message || '接口请求失败')
    } else {
      // 成功时直接返回数据部分
      return res.data
    }
  },
  error => {
    // 网络错误或后端未返回数据时的处理
    console.error('响应拦截器错误:', error)
    Message({
      message: '网络错误，请稍后重试',
      type: 'error',
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export default service